<br>
<p-toast></p-toast>
<div style="width: auto; overflow: auto">
  <app-common-list-table
    [request]="getRequest"
    [filtering]="filter"
    [cols]="cols"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    actionButtonText="Añadir Maquinaria"
    (actionButtonClick)="add()"
    (visualize)="show('info', $event)"
    (edit)="edit($event)"
    (remove)="show('delete', $event)"
  >
    <ng-template #header>
      <div *ngIf="showMaquinariaMostrarTodos" class="d-flex justify-content-start align-content-center">
        <p-inputSwitch
          [style]="{marginLeft: '15px', marginRight: '10px'}"
          [(ngModel)]="showAll"
          (onChange)="changeShowAll(); filter ? filter.filter() : null">
        </p-inputSwitch>
        <p style="color: white; font-size: 1.2em; margin-bottom: 0">Mostrar todos</p>
      </div>
    </ng-template>

    <ng-template #thEnd>
      <th class="rt-actions-col">
        <p class="d-flex justify-content-center mb-0">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data>
      <td class="rt-actions-col">
        <app-action-buttons
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)"
          [hideEdit]="applicationType === 'cropgest' && currentUser.tipo === 'comunero' && data.data.tipo_usuario === 'aplicador'"
          [hideDelete]="applicationType === 'cropgest' && currentUser.tipo === 'comunero' && data.data.tipo_usuario === 'aplicador'">
        </app-action-buttons>
      </td>
    </ng-template>
  </app-common-list-table>
</div>


<p-dialog *ngIf="canShow['info']" header="Detalle del registro" [(visible)]="canShow['info']" (onShow)="scrollToTop()">

  <div class="container grid">
    <div class="row">
      <div class="col">
        <app-form-builder [fields]="formFields" [distributionColumns]="3" [model]="model">
        </app-form-builder>
      </div>
      <div *ngIf="imagenAdjunto" class="col">
        <img  style="width: 45%;" [src]="imagenAdjunto" alt="">
      </div>
      <div *ngIf="model.adjunto_pdf" class="col flex  justify-center align-content-center">
        <button class="btn btn-info w-50 text-white"  (click)="verAdjuntoPdf()">Ver documento</button>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="hide('info')">Cerrar</button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  *ngIf="canShow['delete']"
  header="Eliminar registro"
  [(visible)]="canShow['delete']"
  (onShow)="scrollToTop()"
>

  <div style="width: 80vw !important">
    <app-form-builder
            [fields]="formFields"
            [distributionColumns]="3"
            [model]="model">
    </app-form-builder>
    <br>
    <div class="d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="hide('delete')">Cerrar</button>
      <app-request-button
              (click)="deleteRegister()"
              [request]="deleteRequest"
              [mode]="deleteRequestButtonType">
      </app-request-button>
    </div>
    <br>
  </div>
  <ng-template #footer>
    <p *ngIf="deleteRequest.hasError === undefined && !deleteRequest.isLoading"
       style="color: red; text-align: center">
      ¿Está seguro de eliminar este registro?
    </p>

  </ng-template>
</p-dialog>